@switch (offerTypeCode) {
@case (offerTypeCodeEnum.Direct_Percentage_Discount) {
<p class="badge-status-circle blue">
  {{"offers.directPercentageDiscount" | translate}}
</p>
}
@case (offerTypeCodeEnum.Cash_back) {
<p class="badge-status-circle purple">
  {{"offers.cashback" | translate}}
</p>
}
@case (offerTypeCodeEnum.Free_Product) {
<p class="badge-status-circle orange">
  {{"offers.freeProduct" | translate}}
</p>
}
}
